export const DEFAULT_DATE = '2024-01-01';
export const TIME_FORMAT = 'HH:mm';
export const MINUTE_STEPS = 30;
export const DEFAULT_FROM = '2022-04-17T09:00';
export const DEFAULT_TO = '2022-04-17T17:00';
